import {Component, Input, OnInit} from '@angular/core';
import _default from "chart.js/dist/plugins/plugin.tooltip";
import backgroundColor = _default.defaults.backgroundColor;
import {GlobalService} from "../../../services/global.service";
import {Router} from "@angular/router";
import {NgIf} from "@angular/common";
import {TemplateComponent} from "../../template/template.component";

@Component({
    selector: 'app-success-story-item',
    standalone: true,
    imports: [
        NgIf
    ],
    templateUrl: './success-story-item.component.html',
    styleUrl: './success-story-item.component.css'
})
export class SuccessStoryItemComponent extends TemplateComponent implements OnInit{

    @Input() logoPath: string = "";
    @Input() backImage: string = "";
    @Input() backColor: string = "#000000";
    @Input() fontColor: string = "";
    @Input() title: string = '';
    @Input() text: string = '';
    @Input() pageName: string = '';
    @Input() pageUid: string = '';


    // constructor(public route: Router) {
    // }

    ngOnInit(): void {
        if(this.fontColor.length<1) {
            if (this.isTooDark(this.backColor)) {
                this.fontColor = "#ffffff";
            } else {
                this.fontColor = "#000000";
            }
        }
    }
    isTooDark(hexcolor) {
        let r = parseInt(hexcolor.substr(1, 2), 16);
        let g = parseInt(hexcolor.substr(3, 2), 16);
        let b = parseInt(hexcolor.substr(4, 2), 16);
        let yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        // Return new color if to dark, else return the original
        return (yiq < 100) ? true : false;
    }


        goToPage() {
            this.route.navigateByUrl('/', {skipLocationChange: true}).then(() => {
                this.route.navigate(['success_story/'+this.pageUid]);
            });

        }


}
